import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "#root/routes/constants";
import { showToast } from "#root/components/GlobalToaster";
import { useUpdateGeneralContact, useGeneralContactById } from "#root/queries/generalContacts";
import ContactForm from "../ContactForm";
import LoadingWrapper from "#root/components/LoadingWrapper";
import { Breadcrumbs } from "#root/components/Breadcrumbs";
import { NotepadPersonRegular } from "@fluentui/react-icons";

const EditContact: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const contactId = searchParams.get('contactId');

    const { data: contact, isLoading } = useGeneralContactById({ id: contactId! });
    const updateGeneralContactMutation = useUpdateGeneralContact();

    const handleSubmit = async (contact: any) => {
        if (!contactId) return;

        try {
            await updateGeneralContactMutation.mutateAsync({
                id: contactId,
                generalContact: contact
            });
            showToast('General contact updated successfully', 'success');
            navigate(ROUTES.VTRACKER.ALL_CONTACTS);
        } catch (error) {
            showToast('Failed to update general contact', 'error');
            throw error;
        }
    };

    return (
        <div className="edit-contact">
            <div className="emc-page-header">
                <div className="emc-page-header__top-row">
                    <div className="emc-page-header__breadcrumbs">
                        <Breadcrumbs />
                    </div>
                </div>
                <div className="emc-page-header__title">
                    <h2>General Contact <div className="divider"></div></h2>
                </div>
            </div>

            <LoadingWrapper
                isLoading={isLoading}
                isEmpty={!contact}
                emptyMessage="Contact not found"
                emptyIcon={<NotepadPersonRegular />}
            >
                <ContactForm
                    initialData={contact?.item}
                    onSubmit={handleSubmit}
                    submitButtonText="Save"
                    isSubmitting={updateGeneralContactMutation.isPending}
                />
            </LoadingWrapper>
        </div>
    );
};

export default EditContact;
